import { baseApi } from '../baseApi';
import { API_HEADERS, API_PATHS } from '@/constants';
import { getAccessToken } from '@/services/token';
import { isAuthTokenUnavailableError } from '../authTokenError';
import type { EmployeeSearchResponse } from '@store/models';

let refreshTokenPromise: Promise<string | null> | null = null;

function refreshEmployeeSearchToken(): Promise<string | null> {
  refreshTokenPromise ??= getAccessToken({ forceRefresh: true }).finally(() => {
    refreshTokenPromise = null;
  });
  return refreshTokenPromise;
}

export const employeeServiceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchEmployees: builder.query<EmployeeSearchResponse, string>({
      queryFn: async (filtertext, _queryApi, _extraOptions, baseQuery) => {
        const url = `${API_PATHS.EMPLOYEE_SEARCH}?filtertext=${encodeURIComponent(filtertext)}`;
        let result = await baseQuery(url);

        if (result.error?.status === 401 || isAuthTokenUnavailableError(result.error)) {
          const refreshedToken = await refreshEmployeeSearchToken();

          if (refreshedToken) {
            result = await baseQuery({
              url,
              headers: {
                [API_HEADERS.AUTHORIZATION]: `Bearer ${refreshedToken}`,
              },
            });
          }
        }

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as EmployeeSearchResponse };
      },
    }),
  }),
});

export const { useLazySearchEmployeesQuery } = employeeServiceApi;
